import _ from 'lodash'
import traverse from 'traverse'

import {
  CHANGE_PORTAL,
  SET_PORTAL,
  SET_PROFILE_IMAGE,
  UPDATE_PROFILE_IMAGE,
  REMOVE_PROFILE_IMAGE,
  ADD_GALLERY_IMAGE,
  UPDATE_GALLERY_IMAGE,
  REMOVE_GALLERY_IMAGE,
  UPDATE_GALLERY_IMAGES,
  ADD_LINK_IMAGE,
  UPDATE_LINK_IMAGE,
  REMOVE_LINK_IMAGE,
  UPDATE_LINK_IMAGES,
  COPY_CONTENT_FROM_LANGUAGE,
} from '../constants/actions'
import { setIn } from '../modules/utils'

export default (state = {}, action) => {
  switch (action.type) {
    case SET_PORTAL:
      return action.portal
    case CHANGE_PORTAL:
      return setIn(action.path, action.value, state)
    case SET_PROFILE_IMAGE:
    case UPDATE_PROFILE_IMAGE:
    case REMOVE_PROFILE_IMAGE:
      return {
        ...state,
        mainImageId: action.mainImageId,
        mainImageLastChecked: action.mainImageLastChecked,
      }
    case ADD_GALLERY_IMAGE:
    case UPDATE_GALLERY_IMAGE:
    case UPDATE_GALLERY_IMAGES:
    case REMOVE_GALLERY_IMAGE:
      return setIn('galleryImages', action.galleryImages, state)
    case ADD_LINK_IMAGE:
    case UPDATE_LINK_IMAGE:
    case UPDATE_LINK_IMAGES:
    case REMOVE_LINK_IMAGE:
      return setIn('links', action.links, state)
    case COPY_CONTENT_FROM_LANGUAGE:
      const newState = { ...state }
      traverse(newState).forEach(function(item) {
        if (item && item.lang) {
          this.update(copyContentFromLang(item, action.langFrom, action.langTo))
        }
      })
      return {
        ...newState,
        localModifiedDate: new Date().toISOString(),
      }
    default:
      return state
  }
}

const copyContentFromLang = (obj, langFrom, langTo) => {
  return {
    ...obj,
    [langTo]: _.isEmpty(obj[langTo]) ? obj[langFrom] || '' : obj[langTo],
  }
}



// WEBPACK FOOTER //
// ./src/reducers/portal.js